import { ERROR_STATUS_CODE_400, ERROR_STATUS_CODE_401, ERROR_STATUS_CODE_403, ERROR_STATUS_CODE_404, ERROR_STATUS_CODE_406, ERROR_STATUS_CODE_409, ERROR_STATUS_CODE_410, ERROR_STATUS_CODE_413, ERROR_STATUS_CODE_422, ERROR_STATUS_CODE_500 } from "globals/constants";

import { notifyError } from "./errorNotification";

export const responseErrorHandler = (error, messages) => {
	switch (error.response.status) {
	case ERROR_STATUS_CODE_400:
		if (messages && messages[ERROR_STATUS_CODE_400]) {
			notifyError(messages[ERROR_STATUS_CODE_400], error);
		}
		break;
	case ERROR_STATUS_CODE_401:
		if (messages && messages[ERROR_STATUS_CODE_401]) {
			notifyError(messages[ERROR_STATUS_CODE_401], error);
		}
		break;
	case ERROR_STATUS_CODE_403:
		if (messages && messages[ERROR_STATUS_CODE_403]) {
			notifyError(messages[ERROR_STATUS_CODE_403], error);
		}
		break;
	case ERROR_STATUS_CODE_404:
		if (messages && messages[ERROR_STATUS_CODE_404]) {
			notifyError(messages[ERROR_STATUS_CODE_404], error);
		}
		break;
	case ERROR_STATUS_CODE_406:
		if (messages && messages[ERROR_STATUS_CODE_406]) {
			notifyError(messages[ERROR_STATUS_CODE_406], error);
		}
		break;
	case ERROR_STATUS_CODE_409:
		if (messages && messages[ERROR_STATUS_CODE_409]) {
			notifyError(messages[ERROR_STATUS_CODE_409], error);
		}
		break;
	case ERROR_STATUS_CODE_410:
		if (messages && messages[ERROR_STATUS_CODE_410]) {
			notifyError(messages[ERROR_STATUS_CODE_410], error);
		}
		break;
	case ERROR_STATUS_CODE_413:
		if (messages && messages[ERROR_STATUS_CODE_413]) {
			notifyError(messages[ERROR_STATUS_CODE_413], error);
		}
		break;
	case ERROR_STATUS_CODE_422:
		if (messages && messages[ERROR_STATUS_CODE_422]) {
			notifyError(messages[ERROR_STATUS_CODE_422], error);
		}
		break;
	case ERROR_STATUS_CODE_500:
		if (messages && messages[ERROR_STATUS_CODE_500]) {
			notifyError(messages[ERROR_STATUS_CODE_500], error);
		}
		break;
	default:
		notifyError("An unexpected error occurred. Please try again later.", error);
	}
};